export default {
    userInfos: undefined, // 用户数据
    userIdentity: -1, // 用户身份 0-未选择 1-医疗用户 2-企业用户 3-其他用户
    isLogin: undefined, // 是否登录
    tokenInfo: {}, // 用户凭证
    userID: ''
}